var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { AssistantClient } from './assistantClient';
export const EMPTY_CLIENT = {
    getCookie: () => __awaiter(void 0, void 0, void 0, function* () { }),
    fetchInitSessionInfo: () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => {
            resolve({ sessionId: '', zeroStateExperienceFlag: true, chatHistory: [] });
        });
    }),
    submitFeedback: () => __awaiter(void 0, void 0, void 0, function* () { }),
};
const ClientContext = createContext(EMPTY_CLIENT);
export const useClient = () => useContext(ClientContext);
export function ClientProvider(props) {
    const client = useMemo(() => {
        return new AssistantClient(props.endpoint, props.initData);
    }, [props.endpoint, props.initData]);
    return (_jsx(ClientContext.Provider, { value: client, children: props.children }));
}
